import { forwardRef, InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: string;
  helperText?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, helperText, className, ...props }, ref) => {
    return (
      <label className={cn("flex items-start gap-3 cursor-pointer", className)}>
        <div className="relative flex items-center">
          <input
            ref={ref}
            type="checkbox"
            className="peer sr-only"
            {...props}
          />
          <div
            className={cn(
              "w-5 h-5 rounded border-2 transition-all duration-150",
              "bg-(--color-surface-primary)",
              "border-[var(--color-surface-border)]",
              "peer-checked:bg-[var(--color-primary)]",
              "peer-checked:border-[var(--color-primary)]",
              "peer-focus:ring-2 peer-focus:ring-[var(--color-primary)]/20",
              "peer-disabled:opacity-50 peer-disabled:cursor-not-allowed"
            )}
          >
            <svg
              className={cn(
                "w-3 h-3 text-white absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
                "opacity-0 peer-checked:opacity-100 transition-opacity duration-150"
              )}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={3}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>
        <div className="flex-1">
          {label && (
            <span className="text-[14px] text-(--color-text-primary)">
              {label}
            </span>
          )}
          {helperText && (
            <p className="text-[12px] text-(--color-text-muted) mt-0.5">
              {helperText}
            </p>
          )}
        </div>
      </label>
    );
  }
);

Checkbox.displayName = "Checkbox";
